var React = require('react');

function IconLinkedinWhiteInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M37.464-232.29C16.81-232.29.042-215.948.042-195.803v436.4c0 20.146 16.768 36.467 37.422 36.467h431.333c20.654 0 37.4-16.321 37.4-36.467v-436.4c0-20.145-16.746-36.489-37.4-36.489zm78.289 85.51c26.152 0 42.26 17.165 42.755 39.734 0 22.072-16.589 39.755-43.244 39.755h-.511c-25.658 0-42.245-17.683-42.245-39.755 0-22.569 17.091-39.733 43.245-39.733zM341.13-41.29c50.297 0 88 32.863 88 103.51v131.89h-76.444V71.064c0-30.922-11.051-52.022-38.711-52.022-21.116 0-33.704 14.238-39.222 27.978-2.023 4.905-2.534 11.768-2.534 18.644V194.11h-76.444s1.004-208.42 0-230h76.444v32.6c10.152-15.677 28.306-38 68.911-38zm-264.11 5.4h76.466v230H77.019z","fill":"#fff"}));
}

IconLinkedinWhiteInline.defaultProps = {"width":"44.486","height":"44.768","viewBox":"0 0 506.156 44.768"};

module.exports = IconLinkedinWhiteInline;

IconLinkedinWhiteInline.default = IconLinkedinWhiteInline;
